var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCityBike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 25",
    "aria-label": "sykkel",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#008a34",
    fillRule: "evenodd",
    d: "M18.68 16.58a1 1 0 001.863-.728l-.905-2.316a2.688 2.688 0 11-1.868.714l.91 2.33zm-1.668-4.27a4.688 4.688 0 101.866-.72l-2.713-6.947a1 1 0 10-1.863.727l1.354 3.467a8.599 8.599 0 00-1.044.618c-.963.664-2.016 1.666-2.615 2.977-.25.546-.436.975-.59 1.329-.133.305-.241.554-.344.772L8.452 7.844a1 1 0 00-.264-1.964H5.812a1 1 0 000 2h.506l1.964 5.027a4.688 4.688 0 101.28 4.254h1.72l.222-.12c.62-.332.957-.83 1.249-1.41.147-.293.318-.684.523-1.153.158-.362.337-.77.54-1.214.4-.876 1.15-1.624 1.931-2.163.222-.152.438-.283.64-.391l.625 1.6zm-9.356 3.913a2.687 2.687 0 01-5.349.375H4.72a1 1 0 00.81-.413l1.346-1.857c.483.486.781 1.156.781 1.895z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCityBike);
export default __webpack_public_path__ + "static/media/cityBike.ec805d3b.svg";
export { ForwardRef as ReactComponent };